import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
// import LocationPageLayer from "../components/LocationLayerPage";
import PodcastPageLayer from "../components/PodcastPageLayer";
// import FormPageLayer from "../components/FormPageLayer";



const PodcastPage = () => {
    return (
        <>

            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="PodcastPage" header="Podcast " />

                {/* FormPageLayer */}
                <PodcastPageLayer />


            </MasterLayout>

        </>
    );
};

export default PodcastPage;
